import { render, staticRenderFns } from "./ContactSwitchScreen.vue?vue&type=template&id=2c549996&scoped=true"
import script from "./ContactSwitchScreen.vue?vue&type=script&lang=js"
export * from "./ContactSwitchScreen.vue?vue&type=script&lang=js"
import style0 from "./ContactSwitchScreen.vue?vue&type=style&index=0&id=2c549996&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c549996",
  null
  
)

export default component.exports